<script>

	/* video extends intro {
		...
		html: string
	} */

	export let html;

</script>

<figure>
	<div>
		{@html html}
	</div>
</figure>

<style>

	div {
		width: 100%;
		padding-top: 56.25%;
		position: relative;
	}
	
	@media (max-height: 75vw) {
		figure {
			display: flex;
			justify-content: center;
			align-items: center;
		}
		div {
			height: var( --introHeight );
			width: calc( var( --introHeight ) * 1.777 );
			padding-top: 0;
		}
	}

	figure :global( iframe ){
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

</style>